<template>
  <header class="c-header w-100 pb-0">
    <div class="container position-relative">
      <div
        v-if="general.data.information"
        class="d-flex flex-column flex-md-row justify-content-md-between py-2 align-items-center"
      >
        <div class="d-md-flex align-items-center text-center text-lg-start mb-md-0">
          <p class="sec-color fs-14 w-medium mb-0 me-lg-4">
            <span class="pri-alt fs-21 me-1">
              <Icon icon="ph:phone-bold"/>
            </span>
            {{general.data.information.telephone}} / {{general.data.information.phone}}
          </p>
          <a href="">
            <span class="pri-alt fs-21 me-1">
              <Icon icon="octicon:mail-16"/>
            </span>
            {{general.data.information.email}}
          </a>
        </div>
        <div class="c-social d-none d-lg-flex">
          <a
            target="_blank"
            v-if="general.data.information.facebook"
            :href="general.data.information.facebook"
            class="c-social__link"
          >
            <span>
              <Icon icon="ri:facebook-fill"/>
            </span>
          </a>
          <a
            target="_blank"
            v-if="general.data.information.youtube"
            :href="general.data.information.youtube"
            class="c-social__link"
          >
            <Icon icon="iconoir:youtube"/>
          </a>
          <a
            target="_blank"
            v-if="general.data.information.instagram"
            :href="general.data.information.instagram"
            class="c-social__link"
          >
            <Icon icon="fe:instagram"/>
          </a>
          <a
            target="_blank"
            v-if="general.data.information.linkedin"
            :href="general.data.information.linkedin"
            class="c-social__link"
          >
            <Icon icon="ri:linkedin-fill"/>
          </a>
        </div>
      </div>
      <div class="c-wr"></div>
      <nav class="c-nav w-100">
        <div class="c-nav__left d-flex justify-content-center align-items-center">
          <figure class="c-brand c-brand--normal d-flex justify-content-center align-items-center">
            <router-link class="c-brand__link" to="/">
              <img class="c-brand__image" src="@/assets/images/logo.png" alt="Panda WP - Logo" />
            </router-link>
          </figure>
        </div>
        <div class="c-nav__right">
          <ul class="c-menu menu ul-reset">
            <li
              v-for="item of general.data.primary_menu"
              :key="item.id"
              :class="[item.class, {'activate' : isAtiveMenuItem(item)}]">
              <router-link :to="item.url" class="position-relative" replace>
                {{ item.name }}
              </router-link>
            </li>
          </ul>
          <div class="d-none d-lg-flex gap-4 me-4">
            <router-link
              to="/"
              class="c-link"
              :class="{ 'active': $route.name === 'Home' }"
            >
              Inicio
            </router-link>
            <router-link
              to="/nosotros"
              class="c-link"
              :class="{ 'active': $route.name === 'About' }"
            >
              Nosotros
            </router-link>
            <router-link
              to="/servicios"
              class="c-link"
              :class="{ 'active': $route.name === 'Services' }"
            >
              Servicios
            </router-link>
            <router-link
              to="/noticias"
              class="c-link"
              :class="{ 'active': $route.name === 'Notices' }"
            >
              Noticias
            </router-link>
            <router-link
              to="/contacto"
              class="c-link"
              :class="{ 'active': $route.name === 'Contact' }"
            >
              Contacto
            </router-link>
            <router-link
              to="/responsabilidad-social"
              class="c-link"
              :class="{ 'active': $route.name === 'responsabilidad-social' }"
            >
              Responsabilidad Social
            </router-link>
          </div>

          <div class="d-flex align-item-center gap-lg-2">
            <a
            target="_blank"
              v-if="general.data.information"
              :href="general.data.information.brochure"
              class="c-button c-button--primary px-2 px-xl-3"
            >
            <span class="fs-25 d-flex me-1">
              <Icon icon="material-symbols:download"/>
            </span>
            Brochure
            </a>

            <button @click="$bvModal.show('modalVideo')"
              class="c-button c-button--primary px-2 px-xl-3">
              Ver video
            </button>
          </div>

        </div>
      </nav>
    </div>

  <b-modal
    id="modalVideo"
      title="BootstrapVue" hide-footer hide-header hide-actions centered size="xl"
    >
      <div class="
        c-modal c-modal--gallery
        d-flex align-items-ends justify-content-center
        flex-column"
        >
        <div class="text-end mt-0">
          <div class="text-end pe-3 c-modal__cross mb-2">
            <span @click="$bvModal.hide('modalVideo')" class=" fs-30">
              <Icon icon="gridicons:cross-circle" />
            </span>
          </div>
        </div>
        <div class="c-video w-100" v-html="general.data.information.video_institucional">
        </div>
      </div>
    </b-modal>
  </header>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['general']),
  },
  methods: {
    isAtiveMenuItem(item) {
      return item.slug.toLowerCase() === this.$route.name.toLowerCase();
    },
  },
};
</script>
